import { render, staticRenderFns } from "./OnboardingOverview.vue?vue&type=template&id=2dc2e1cb&"
import script from "./OnboardingOverview.vue?vue&type=script&lang=ts&"
export * from "./OnboardingOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports